import script from "./DTIRatio.vue?vue&type=script&lang=ts&setup=true"
export * from "./DTIRatio.vue?vue&type=script&lang=ts&setup=true"

import "./DTIRatio.vue?vue&type=style&index=0&id=18618414&lang=scss"

const __exports__ = script;

export default __exports__